import React, { Component } from 'react'
import { graphql } from 'gatsby'
import '../../static/scripts/vendors/lodash.custom.min.js'
import Helmet from '../components/helmet.component'
import Layout from '../components/layout'
import BlockComponent from '../components/block.component'
import { isBrowser,getUrlParameter, getCountryCodeAndLanguage, getLoginUrl, removeFromStorage } from '../utils/common.js'
import SignupOverlayNotification from "../components/signupoverlay-notification.component"
import WubotComponent from '../components/wubot.component.js'
import FooterComponent from '../components/footer.component.js'
const replaceImageStyle = (
  content
) => {
  return content && content.replace(/<img style="max-width:100%;width:100px"/g, '<img ')
  .replace(/wushop-test.westernunion.com/g, 'wushop.westernunion.com');
  // return contentUpdated;
}

export default class Page extends Component {
  constructor(props) {
    super(props);
    this.state = {
      wuUserLoginStaus: false,
      showOverlayNotification: false
    }
  }

  componentDidMount() {
    this.setLoggedInUserNameHeader();
    this.handleOverlayNotification();
    this.setClickEventOnLogoutLink();
    this.setHeaderLink();
    this.setAnalyticsEventsForPopUp();
    if(this.props.pageContext.isGlobal){
      document.querySelector(".entry-content").innerHTML = this.headerContentCookie;     
      document.querySelector("footer").innerHTML = this.footerContentCookie;
      }
  }


  setAnalyticsEventsForPopUp(){
    const getLoginButtonHeroBanner = document.getElementById("mywu-hero-banner-login-button");
    getLoginButtonHeroBanner.addEventListener("click", this.setPageLoadEventsInAnalytics);

    const loginButtonInsidePopUp = document.getElementById("myWuLoginBtn");
    loginButtonInsidePopUp.addEventListener("click", this.setLoginTypeInAnalytics);

    const closeButtonInsidePopUp = document.getElementById("popup-login-close-btn");
    closeButtonInsidePopUp.addEventListener("click", this.setPopUpCloseButtonInAnalytics);
  }

  setPageLoadEventsInAnalytics(){
    if (isBrowser){
      sessionStorage.setItem('loginPopClicked', true);
      window.loadPageViewEvents();
    } 
  }

  setLoginTypeInAnalytics(){
    const  radioButtons  = document.querySelectorAll('input[name="mywu-login"]');
    for (const radioButton of radioButtons) {
      if (radioButton.checked) {
        isBrowser && window.setAnalyticsSections(radioButton.value);
          break;
      }
  }
  }

  setPopUpCloseButtonInAnalytics(){
    if (isBrowser){
      sessionStorage.setItem('loginPopClicked', false);
      window.loadPageViewEvents();
    } 
  }

  setHeaderLink() {
    if (location.host.indexOf('www2.') !== -1) {
      const wuShopLinks = document.querySelectorAll("a[href*='wushop.westernunion.com']");
      for (let i = 0; i < wuShopLinks.length; i++){
        const getUrlWuShop = wuShopLinks[i].getAttribute('href');
        wuShopLinks[i].setAttribute('href', getUrlWuShop.replace('wushop.westernunion.com', 'wushop-test.westernunion.com'));
      }
      
    }
  }

  terminateSessionService = () => {
    const cookieStore =  window.sessionStorage.cookiestore;
    const codeObjForBashPath = getCountryCodeAndLanguage();
    const {countryCode, langCode} = codeObjForBashPath;
    const getOrigin = window.location.origin;
    const url = `${getOrigin}/wuconnect/rest/api/v1.0/TerminateSession?timestamp=${new Date().getTime()}`
    const bashPath = `/${countryCode}/${langCode}`
    const getTerminateSessionRequestBody = {
      "security": {
        "session": {
          "id": JSON.parse(cookieStore)["SessionId"]
        }
      },
      "bashPath": bashPath
    };
    let xhttp;
    xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = () => {
      if (
        xhttp.readyState === 4 && xhttp.status === 200
      ) {
        console.log('Session has been terminated successfully!!');
        removeFromStorage();
        window.location.href = getLoginUrl();
      }
    };
    xhttp.open("POST", url, true);
    xhttp.setRequestHeader("Content-type", "application/json");
    xhttp.setRequestHeader("Accept", "application/json");
    xhttp.send(JSON.stringify(getTerminateSessionRequestBody));
  }

  logoutHandler = (event) => {
    try {
      this.terminateSessionService();
    } catch (error) {
      console.log(error);
      removeFromStorage();
      window.location.href = getLoginUrl();
    }
  }

  setClickEventOnLogoutLink() {
    const item = document.getElementById("user-logout-link");
    const item2 = document.getElementById("wu-mobile-logout-button");
    item && item.addEventListener("click", this.logoutHandler);
    item2 && item2.addEventListener("click", this.logoutHandler);
  }

  setLoggedInUserNameHeader() {
    let isEmailVerificationRequired = JSON.parse(window.sessionStorage.getItem('C1124'));
    if (window.sessionStorage.AccountNumber && !isEmailVerificationRequired) {
      this.setState({
        wuUserLoginStaus: true
      }, function () {
        if (this.state.wuUserLoginStaus && window.sessionStorage.FirstName) {
          let firstname = window.sessionStorage.FirstName;
          let lastname = window.sessionStorage.LastName;
          if (firstname) {
            let fullname = `${firstname} ${lastname ? lastname : ''}`
            fullname = fullname.toLowerCase().replace(/\b[a-z]/g, function (letter) {
              return letter.toUpperCase();
            });
            if (window.matchMedia("(min-width: 992px) and (max-width: 1145px)").matches) {
              if (fullname.length > 10) fullname = fullname.substring(0, 10) + '...';
            } else if (window.matchMedia("(min-width: 1145px").matches) {
              if (fullname.length > 20) fullname = fullname.substring(0, 20) + '...';
            }
            const loggedInSection = document.querySelector("#loggedInSection");
            const mobileLoggedInSection = document.querySelector("#mobileLoggedInSection"); 
            const mobileLoginSection = document.querySelector("[data-mobile-menu-content] .nav-dropdown div.pad-xs-horz");
            const navItemLink = document.querySelector(`.wu-header__logo-container .nav-item__link`);
            const navItem = document.querySelectorAll(`a[data-href]`);
            for(let item=0;item<navItem.length;item++) {
              const element = navItem[item];
              let dataHrefAttributeVal = element.getAttribute('data-href');
              element.setAttribute('href', dataHrefAttributeVal);
            }
            // if(mobileLoggedInSection){
              loggedInSection && loggedInSection.classList.add('d-M-flex');
              mobileLoggedInSection.className = mobileLoggedInSection.className.replace('d-none','d-none d-flex');
              document.querySelector("#mobileLogInRegisterSection").classList.remove('d-flex')
              document.querySelector("#mobileLogInRegisterSection").classList.add('d-none')
              // document.querySelector("#loggedInSection .text-action-light-200").innerHTML = fullname;
              // document.querySelector("#mobileLoggedInSection .text-action-light-200").innerHTML = fullname;
              document.querySelector('.font-body-reg.white-space-nowrap.text-granite-300.text-center.mar-xs-tp').innerHTML = fullname
              let hrefLogo = navItemLink && navItemLink.getAttribute(`href`);
              if(hrefLogo) {
                hrefLogo = hrefLogo.replace(`home.html`,`web/send-money/start`);
                navItemLink.setAttribute(`href`,hrefLogo);
              }
            // }
            var signUpNavItem = document.querySelectorAll("#sign-up-nav-item"),
              loginNavItem = document.querySelectorAll("#login-nav-item"),
              wuUserIconNavItem = document.querySelectorAll("#wu-user-icon-nav-item"),
              userLoggedInNavItem = document.querySelectorAll("#user-logged-in-nav-item")

            Array.from(signUpNavItem).forEach((e) => {
              e.className = e.className.replace('d-L-block', 'd-none')
            })
            Array.from(loginNavItem).forEach((e) => {
              e.className = e.className.replace('d-L-block', 'd-none')
            })
            Array.from(wuUserIconNavItem).forEach((e) => {
              e.className = e.className.replace('d-none', 'd-none d-L-block')
            })
            Array.from(userLoggedInNavItem).forEach((e) => {
              e.className = e.className.replace('d-none', 'd-none d-L-block')
            })

            document.querySelector('.wu-user-loggedin-section.pt-0.pb-0.wu-logged-in-section__text.text-granite-300').innerHTML = fullname
            // mobileLoginSection.className = mobileLoginSection.className.replace('d-flex','d-none');
          }
        }
      });
    }
  }

  handleOverlayNotification() {
    if (sessionStorage.getItem('loggedInByOverlay') === 'true') {
      window.history.scrollRestoration = 'manual';
      for (const item in sessionStorage) {
        /^@@scroll/.test(item) && sessionStorage.removeItem(item);
      }
      this.setState({ showOverlayNotification: true });
    }
  }

  getReplacedCurrencyCode(seoData,senderCurrency,receiverCurrency) {
    return seoData && seoData.replace(/{senderCurrencyCode}/gi, senderCurrency)
                             .replace(/{receiverCurrencyCode}/gi, receiverCurrency)
  }

  getReplacedCurrencyName(seoData,senderCurrencyName,receiverCurrencyName) {
    return seoData && seoData.replace(/{senderCurrencyName}/gi, senderCurrencyName)
                             .replace(/{receiverCurrencyName}/gi, receiverCurrencyName)
  }

  getDynamicSeoData(title,isSlug){
    return title.split("##").length >1 && isSlug ? title.split("##")[1]: title.split("##")[0];
  }
  getAppBannerData(countryThemeSetting, language){
    if(language == "en"){
      return countryThemeSetting && countryThemeSetting.countryThemeSettings && countryThemeSetting.countryThemeSettings.appBanner;
    } else{
      let getLanguageNode = countryThemeSetting && countryThemeSetting.languageCountryThemeSetting && countryThemeSetting.languageCountryThemeSetting.languageCountryThemeSettings &&
                            countryThemeSetting.languageCountryThemeSetting.languageCountryThemeSettings.find(o => o.language === language)
      return getLanguageNode && getLanguageNode['appBanner'];
    }
  }
 
  render() {
    const { pageContext, data : { page , countryThemeSetting } } = this.props
    const  {
      pageContent,
      blocks,
      seoMetaData,
      slug,
      headerFooterContent,
      headerContent,
      footerContent,
      switchContent,
      criticalCss,
      mainCssContent,
      isCurrencyConverter,
      isGlobal,
      language,
      country
    } = pageContext
    const appBanner =  this.getAppBannerData(countryThemeSetting, language)
    let { seo } = page
    if (isBrowser() && isGlobal) {
     const codeObjForBashPath = getCountryCodeAndLanguage();
     const countryLang = `_${codeObjForBashPath.countryCode}_${codeObjForBashPath.langCode}`;
      this.headerContentCookie = headerFooterContent[`headerContent${countryLang}`] ? headerFooterContent[`headerContent${countryLang}`] : headerFooterContent[`headerContent_us_en`];
      this.footerContentCookie = headerFooterContent[`footerContent${countryLang}`] ? headerFooterContent[`footerContent${countryLang}`] : headerFooterContent[`footerContent_us_en`];
    }
    const content = isCurrencyConverter && replaceImageStyle(pageContent);
    let isSlug = /\/currency-converter\/.+\.html$/.test(slug)
    if (seoMetaData) {
      let pageTitle = this.getDynamicSeoData(page["seo"]["title"], isSlug)
      let pageDesc = this.getDynamicSeoData(page["seo"]["metaDesc"], isSlug)
      if (isBrowser()) {
        let sendAmount = getUrlParameter("sendAmount")
        let title = sendAmount ? `${sendAmount} ${seoMetaData.senderCurrency}` : seoMetaData.senderCurrency
        pageTitle =
          pageTitle &&
          this.getReplacedCurrencyCode(
            pageTitle,
            title,
            seoMetaData.receiverCurrency
          )
        pageDesc =
          pageDesc &&
          this.getReplacedCurrencyCode(
            pageDesc,
            title,
            seoMetaData.receiverCurrency
          ) 
        pageDesc = this.getReplacedCurrencyName(pageDesc,seoMetaData.senderCurrencyName,seoMetaData.receiverCurrencyName)
        pageTitle = this.getReplacedCurrencyName(pageTitle,seoMetaData.senderCurrencyName,seoMetaData.receiverCurrencyName) // Showing Currency Name on Page Title 
        page["seo"]["title"] = pageTitle
        page["seo"]["metaDesc"] = pageDesc
      }
    } else {
      page["seo"]["title"] = this.getDynamicSeoData(page["seo"]["title"], isSlug)
      page["seo"]["metaDesc"] = this.getDynamicSeoData(page["seo"]["metaDesc"], isSlug)
    }
    page["seo"]["opengraphTitle"] = page["seo"]["title"]
    page["seo"]["opengraphDescription"] = page["seo"]["metaDesc"]
    let headerContentText = replaceImageStyle(headerContent)
    const footerContentText = replaceImageStyle(footerContent)
    const isHeadless = (page.disable_Header_And_Footer.disableHeaderAndFooter === 'Yes') ? true : false;
    if (isBrowser()) {
      sessionStorage.setItem('switches', switchContent)
    }
    return (
      <>
        <Helmet pageContext={pageContext} seo={ seo } 
                isEvergageEnabled={isSlug ? 'Yes' : page.evergage_Enabled_Page.evergageEnabledPage }
                isWubotEnabled={ page.Wubot_Enabled_Page.wubotEnabledPage }
         />
        <Layout pageContext={pageContext} appBanner = {appBanner} language={language}>
           {isGlobal && <div className="entry-content" ></div>}
          {!isGlobal && !isHeadless && <div className="entry-content" dangerouslySetInnerHTML={{ __html: headerContentText }} />}
          {page.Wubot_Enabled_Page.wubotEnabledPage === 'Yes' && <WubotComponent />}
          {this.state.showOverlayNotification && <SignupOverlayNotification />}
          {/* <div className="entry-content" dangerouslySetInnerHTML={{ __html: content }} /> */}
          { 
            isCurrencyConverter ?
              <div className="entry-content" dangerouslySetInnerHTML={{ __html: content }} /> 
              :
              (blocks && blocks.map((bl, index) => {
                // if (
                //   [0, 1].indexOf(bl.order) === -1
                // ) {
                //   const LazyBlockComponent = loadable(() => import('../components/block.component'))

                //   return (
                //     <LazyBlockComponent
                //       index={index}
                //       content={replaceImageStyle(bl.dynamicContent)}>
                //     </LazyBlockComponent>
                //   )
                // } else {
                  return (
                    <BlockComponent
											index={index}
                      content={replaceImageStyle(bl.dynamicContent)}>
                    </BlockComponent>
                  )
                // }
              }))
          }
          {!isHeadless && <FooterComponent countryDropdownDisable={page.country_dropdown_disable.countryDropdownDisable} content={footerContentText}/>}
          {/* {!isHeadless && <div className="entry-content" dangerouslySetInnerHTML={{ __html: footerContentText }} />} */}
        </Layout>
      </>
    )
  }
}

export const query = graphql`
  query page($id: String!, $countryName: String) {
    page: wpPage(id: { eq: $id }) {
      title
      evergage_Enabled_Page {
        evergageEnabledPage
      }
      Wubot_Enabled_Page {
        wubotEnabledPage
      }
      disable_Header_And_Footer {
        disableHeaderAndFooter
      }
      country_dropdown_disable {
        countryDropdownDisable
      }
      seo {
        canonical
        cornerstone
        focuskw
        metaDesc
        metaKeywords
        metaRobotsNofollow
        metaRobotsNoindex
        opengraphAuthor
        opengraphDescription
        opengraphModifiedTime
        opengraphPublishedTime
        opengraphPublisher
        opengraphSiteName
        opengraphTitle
        opengraphType
        opengraphUrl
        title
        twitterDescription
        twitterTitle
      }
    }
    countryThemeSetting: wpCountryThemeSetting(title: { eq: $countryName }) {
      countryThemeSettings {
        fieldGroupName
        footer {
          copyright
        }
        appBanner {
          description
          downloadButtonText
          fieldGroupName
          smartLink
          title
        }
      }
      languageCountryThemeSetting {
        languageCountryThemeSettings {
          language : selectLanguage
          appBanner {
            description
            downloadButtonText
            fieldGroupName
            smartLink
            title
          }
        }
      }
    }
  }
`
